import { Component, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { HttpService } from 'src/app/http.service';
import { GlobalService } from 'src/app/global.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';


@Component({
  selector: 'app-new-purchase-company',
  templateUrl: './new-purchase-company.component.html',
  styleUrls: ['./new-purchase-company.component.scss']
})
export class NewPurchaseCompanyComponent {
  purchase_company_form: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<NewPurchaseCompanyComponent>,
    @Inject(MAT_DIALOG_DATA) public data, private http: HttpService, private global: GlobalService,
    private formBuilder: FormBuilder) {
    this.purchase_company_form = this.formBuilder.group({
      company_name: [null, Validators.compose([Validators.required])],
      gst_number: [null, Validators.compose([])],
      pan_number: [null, Validators.compose([])],
    });
    console.log(data);
  }

  registerPurchaseCompany() {
    console.log(this.purchase_company_form.value);
    this.http.registerPurchaseCompany(this.purchase_company_form.value).subscribe((data: any) => {
      console.log(data);
      if (data['is_available']) {
        alert('The Giver Purchase Company is already available');
        this.closeComponent(false);
      } else {
        this.closeComponent(true);
      }
    }, (error) => {
      console.error(error);
    });
  }

  closeComponent(data: any) {
    this.dialogRef.close(data);
  }


  ngOnInit() {
  }

}
